module.exports = __webpack_public_path__ + "yamicon.png?bfa44e289e205c17b452eee1256471ba";


//////////////////
// WEBPACK FOOTER
// ./static/images/yamicon.png
// module id = 574
// module chunks = 26